import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import DataCacheService from '@/shared/services/DataCacheService';
import messages from '../invoicingMessages';

const ToInvoiceGlobalActionsButton = props => {
  const { intl, disabled, onAddToInvoiceProposal, onBatchToggleLockRegistrations } = props;
  const allowRegistrationLocking = !!DataCacheService.getDefaultCompany()?.allowRegistrationLocking;

  return (
    <span
      className="tool-tip"
      data-toggle="tooltip"
      data-placement="top"
      title={disabled ? intl.formatMessage(messages.ToInvoiceGlobalActionsTooltip) : ''}
    >
      <DropdownButton
        bsSize="xsmall"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled}
        pullRight
        title={intl.formatMessage(messages.GlobalActions)}
      >
        <MenuItem onSelect={onAddToInvoiceProposal} disabled={disabled}>
          <i class="fa fa-money margin5R"></i>
          {intl.formatMessage(messages.AddToInvoiceProposal)}
        </MenuItem>
        {allowRegistrationLocking && (
          <MenuItem onSelect={() => onBatchToggleLockRegistrations(true)} disabled={disabled}>
            <i class="fa fa-lock fa-fw margin5R"></i>
            {intl.formatMessage(messages.BatchLockRegistrations)}
          </MenuItem>
        )}
        {allowRegistrationLocking && (
          <MenuItem onSelect={() => onBatchToggleLockRegistrations(false)} disabled={disabled}>
            <i class="fa fa-unlock fa-fw margin5R"></i>
            {intl.formatMessage(messages.BatchUnlockRegistrations)}
          </MenuItem>
        )}
      </DropdownButton>
    </span>
  );
};

ToInvoiceGlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  disabled: PropTypes.bool,
  onAddToInvoiceProposal: PropTypes.func.isRequired,
  onBatchToggleLockRegistrations: PropTypes.func.isRequired,
};
ToInvoiceGlobalActionsButton.defaultProps = {
  disabled: false,
};
export default injectIntl(ToInvoiceGlobalActionsButton);
